import axios from "axios";
import Domain from "@/mixins/domain";

const client = axios.create({
  baseURL: Domain.APP_DOMAIN
});

client.interceptors.request.use(config => {
  const token = localStorage.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default client;
